import Vue from 'vue'
import Router from 'vue-router'
import AppModel from '@/models/AppModel'
import fstore from '@/store/florist-store'
import cstore from '@/store/customer-store'
import ConstructionImage from '@/pages/ConstructionImage'
import FloristMeetingIndex from '@/pages/FloristMeetingIndex'
import FloristMeetingAgenda from '@/pages/FloristMeetingAgenda'
import FloristMeetingInput from '@/pages/FloristMeetingInput'
import FloristMeetingConfirm from '@/pages/FloristMeetingConfirm'
import FloristMeetingSendMail from '@/pages/FloristMeetingSendMail'
import FloristMeetingHearing from '@/pages/FloristMeetingHearing'
import FloristMeetingStyleImageProposal from '@/pages/FloristMeetingStyleImageProposal'
import FloristMeetingProductProposal from '@/pages/FloristMeetingProductProposal'
import FloristMeetingProductSelection from '@/pages/FloristMeetingProductSelection'
import FloristMeetingProductionInstruction from '@/pages/FloristMeetingProductionInstruction'
import FloristMeetingEstimate from '@/pages/FloristMeetingEstimate'
import FloristMeetingFinish from '@/pages/FloristMeetingFinish'
import FloristMeetingError from '@/pages/FloristMeetingError'
import TraderLogin from '@/pages/TraderLogin'
import TraderSignup from '@/pages/TraderSignup'
import ProducePropositionList from '@/pages/ProducePropositionList'
import DeliveryImage from '@/pages/DeliveryImage'
import CustomerDirectEstimate from '@/pages/CustomerDirectEstimate'
import CustomerLogin from '@/pages/CustomerLogin'
import CustomerSNSAuth from '@/pages/CustomerSNSAuth'
import CustomerMeetingAgenda from '@/pages/CustomerMeetingAgenda'
import CustomerMeetingInput from '@/pages/CustomerMeetingInput'
import CustomerMeetingConfirm from '@/pages/CustomerMeetingConfirm'
import CustomerMeetingSendMail from '@/pages/CustomerMeetingSendMail'
import CustomerMeetingHearing from '@/pages/CustomerMeetingHearing'
import CustomerMeetingStyleImageProposal from '@/pages/CustomerMeetingStyleImageProposal'
import CustomerMeetingProductProposal from '@/pages/CustomerMeetingProductProposal'
import CustomerMeetingProductSelection from '@/pages/CustomerMeetingProductSelection'
import CustomerMeetingEstimate from '@/pages/CustomerMeetingEstimate'
import CustomerMeetingFinish from '@/pages/CustomerMeetingFinish'
import CustomerUploadImage from '@/pages/CustomerUploadImage'
import ControlItemImageRegistration from '@/pages/ControlItemImageRegistration'
import ControlSpecList from '@/pages/ControlSpecList'
import ControlSpecRegistration from '@/pages/ControlSpecRegistration'
import ControlItemSearch from '@/pages/ControlItemSearch'
import FocusSpecList from '@/pages/FocusSpecList'
import InventorySpecList from '@/pages/InventorySpecList'
import MaterialsAndEquipmentAdjustmentList from '@/pages/MaterialsAndEquipmentAdjustmentList'
import FloristLayout from '@/pages/FloristLayout'

Vue.use(Router)

const consts = require('@/config/consts.json')
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/florist/construction_image',
      name: 'ConstructionImage',
      component: ConstructionImage
    },
    {
      path: '/florist/meeting',
      name: 'FloristMeetingIndex',
      component: FloristMeetingIndex
    },
    {
      path: '/florist/meeting/agenda',
      name: 'FloristMeetingAgenda',
      component: FloristMeetingAgenda
    },
    {
      path: '/florist/meeting/input',
      name: 'FloristMeetingInput',
      component: FloristMeetingInput
    },
    {
      path: '/florist/meeting/confirm',
      name: 'FloristMeetingConfirm',
      component: FloristMeetingConfirm
    },
    {
      path: '/florist/meeting/send_mail',
      name: 'FloristMeetingSendMail',
      component: FloristMeetingSendMail
    },
    {
      path: '/florist/meeting/hearing',
      name: 'FloristMeetingHearing',
      component: FloristMeetingHearing
    },
    {
      path: '/florist/meeting/style_image_proposal',
      name: 'FloristMeetingStyleImageProposal',
      component: FloristMeetingStyleImageProposal
    },
    {
      path: '/florist/meeting/product_proposal',
      name: 'FloristMeetingProductProposal',
      component: FloristMeetingProductProposal
    },
    {
      path: '/florist/meeting/product_selection/:id',
      component: FloristLayout,
      children: [
        {
          path: '',
          name: 'FloristMeetingProductSelection',
          component: FloristMeetingProductSelection
        }
      ]
    },
    {
      path: '/florist/meeting/production_instruction/:id',
      name: 'FloristMeetingProductionInstruction',
      component: FloristMeetingProductionInstruction
    },
    {
      path: '/florist/meeting/estimate',
      name: 'FloristMeetingEstimate',
      component: FloristMeetingEstimate
    },
    {
      path: '/florist/meeting/finish',
      name: 'FloristMeetingFinish',
      component: FloristMeetingFinish
    },
    {
      path: '/florist/meeting/error',
      name: 'FloristMeetingError',
      component: FloristMeetingError
    },
    {
      path: '/customer',
      redirect: '/customer/login'
    },
    {
      path: '/customer/login',
      name: 'CustomerLogin',
      component: CustomerLogin,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/sns_auth',
      name: 'CustomerSNSAuth',
      component: CustomerSNSAuth
    },
    {
      path: '/customer/meeting/agenda',
      name: 'CustomerMeetingAgenda',
      component: CustomerMeetingAgenda,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/input',
      name: 'CustomerMeetingInput',
      component: CustomerMeetingInput,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/confirm',
      name: 'CustomerMeetingConfirm',
      component: CustomerMeetingConfirm,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/send_mail',
      name: 'CustomerMeetingSendMail',
      component: CustomerMeetingSendMail,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/hearing',
      name: 'CustomerMeetingHearing',
      component: CustomerMeetingHearing,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/style_image_proposal',
      name: 'CustomerMeetingStyleImageProposal',
      component: CustomerMeetingStyleImageProposal,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/product_proposal',
      name: 'CustomerMeetingProductProposal',
      component: CustomerMeetingProductProposal,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/product_selection/:id',
      component: FloristLayout,
      children: [
        {
          path: '',
          name: 'CustomerMeetingProductSelection',
          component: CustomerMeetingProductSelection
        }
      ],
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/estimate',
      name: 'CustomerMeetingEstimate',
      component: CustomerMeetingEstimate,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/meeting/finish',
      name: 'CustomerMeetingFinish',
      component: CustomerMeetingFinish,
      meta: { title: 'LINKs（お客様）' }
    },
    {
      path: '/customer/upload_image',
      name: 'CustomerUploadImage',
      component: CustomerUploadImage
    },
    {
      path: '/customer/direct_estimate',
      name: 'CustomerDirectEstimate',
      component: CustomerDirectEstimate
    },
    // 案件管理画面モック用
    {
      path: '/',
      redirect: '/trader/login'
    },
    {
      path: '/trader',
      redirect: '/trader/login'
    },
    {
      path: '/trader/login',
      name: 'TraderLogin',
      component: TraderLogin
    },
    {
      path: '/trader/signup',
      name: 'TraderSignup',
      component: TraderSignup
    },
    {
      path: '/trader/produce_proposition_list',
      name: 'ProducePropositionList',
      component: ProducePropositionList
    },
    {
      path: '/trader/delivery_image',
      name: 'DeliveryImage',
      component: DeliveryImage
    },
    // 外販向け画面
    {
      path: '/control/item_image_registration',
      name: 'ControlItemImageRegistration',
      component: ControlItemImageRegistration
    },
    {
      path: '/control/spec_list',
      name: 'ControlSpecList',
      component: ControlSpecList
    },
    {
      path: '/control/spec_registration',
      name: 'ControlSpecRegistration',
      component: ControlSpecRegistration
    },
    {
      path: '/control/item_search',
      name: 'ControlItemSearch',
      component: ControlItemSearch
    },
    {
      path: '/control/focus_spec_list',
      name: 'FocusSpecList',
      component: FocusSpecList
    },
    {
      path: '/control/inventory_spec_list',
      name: 'InventorySpecList',
      component: InventorySpecList
    },
    {
      path: '/adjustment/materials_and_equipment_list',
      name: 'MaterialsAndEquipmentAdjustmentList',
      component: MaterialsAndEquipmentAdjustmentList
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (from.path.indexOf('control/') === -1 && to.path.indexOf('control/') === -1 && from.path.indexOf('adjustment/') === -1 && to.path.indexOf('adjustment/') === -1) {
    if (from.path === '/florist/meeting' || from.path === '/customer/login') {
      // 打ち合わせ画面表示時の遷移では再表示と同じ処理を行わせる
      sessionStorage.setItem('lastRoutePath', to.path)
    } else if (from.path !== '/') {
      sessionStorage.setItem('lastRoutePath', from.path)
    }
    next()
  } else {
    let userid = to.query.userId
    let toroku = to.query.toroku
    if ('userId' in to.query || 'toroku' in to.query) {
      delete to.query['userId']
      delete to.query['toroku']
      to.meta['userId'] = userid
      to.meta['toroku'] = toroku
      next({
        path: to.path,
        query: to.query,
        meta: { userId: userid, toroku: toroku }
      })
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  document.title = to.meta.title || 'LINKs'

  if (from.path.indexOf('control/') === -1 && to.path.indexOf('control/') === -1 && from.path.indexOf('adjustment/') === -1 && to.path.indexOf('adjustment/') === -1) {
    let hitFlg = false
    for (let i = 0; i < router.options.routes.length; i++) {
      let nowRoutesPath = router.options.routes[i].path.split(':')
      if (nowRoutesPath[0] === to.path || (nowRoutesPath.length > 1 && to.path.startsWith(nowRoutesPath[0]))) {
        hitFlg = true
        break
      }
    }
    if (!hitFlg) {
      return
    }

    // dynamoDBに現在の画面URLと操作権を格納
    const urlPath = to.path
    let currentURLPath = ''
    let operatingPrivilege = '0'
    let attendeeType = ''
    if (urlPath.indexOf('florist/') !== -1) {
      currentURLPath = urlPath.substr(urlPath.indexOf('florist/') + 8)
      operatingPrivilege = fstore.getters.isOperationPossible ? '0' : '1'
      attendeeType = consts.attendeeType.florist
    } else if (urlPath.indexOf('customer/') !== -1) {
      currentURLPath = urlPath.substr(urlPath.indexOf('customer/') + 9)
      operatingPrivilege = cstore.getters.isOperationPossible ? '1' : '0'
      attendeeType = consts.attendeeType.customer
    }
    if (currentURLPath !== 'meeting' && currentURLPath !== 'login' && currentURLPath !== 'meeting/confirm' && currentURLPath !== 'direct_estimate' && currentURLPath !== 'upload_image' && currentURLPath !== 'construction_image' && currentURLPath !== 'sns_auth') {
      let urlquery = ''
      for (const [key, value] of Object.entries(to.query)) {
        if (value) {
          urlquery += key + '=' + value + '&'
        }
      }
      if (urlquery) {
        currentURLPath += '?' + urlquery
      }
      const loginStatus = JSON.parse(localStorage.getItem('loginStatus'))
      if (loginStatus['prodInst'] && loginStatus['prodInst'] !== '1') {
        const params = {
          'currentURLPath': currentURLPath,
          'operatingPrivilege': operatingPrivilege,
          'attendeeType': attendeeType
        }
        let res
        if (currentURLPath !== '') {
          AppModel.post('meeting_url_update', null, params, (res))
        }
      }
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js